export enum ENVIRONMENT_GAME {
  DEV = "https://test.nubii.us/minigames/",
  PRO = "https://test.nubii.us/minigames/",
}

export enum GAME_TYPE {
  PONG = "pongJS/index.html?",
}
